import { auth } from 'api';
import {
  lsSetAuthToken,
  lsRemoveAuthToken,
  lsGetAuthTokenBBVA,
  lsSetAuthTokenBBVA,
  lsRemoveAuthTokenBBVA
} from 'helpers/store';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_VALIDATE,
  AUTH_REQUEST_BBVA,
  AUTH_REQUEST_REFRESH_BBVA
} from 'store/actions/auth';

export default {
  // Validate the token and update it with new API data if it is not valid
  [AUTH_VALIDATE]: ({ dispatch, getters }) => {
    if (getters.isAuthenticated) {
      return Promise.resolve();
    }
    return dispatch(AUTH_REQUEST);
  },

  [AUTH_REQUEST]: ({ commit }) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      auth
        .startSessionApi({
          clientId: process.env.API_CLIENT_ID,
          clientSecret: process.env.API_CLIENT_SECRET,
          scope: process.env.API_SCOPE,
          grantType: process.env.API_GRANT_TYPE
        })
        .then(
          resp => {
            const data = resp.data;
            lsSetAuthToken(data);
            commit(AUTH_SUCCESS, data);
            resolve(data);
          },
          err => {
            commit(AUTH_ERROR, err);
            lsRemoveAuthToken();
            reject();
          }
        );
    }),

  [AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(AUTH_LOGOUT);
      lsRemoveAuthToken();
      resolve();
    }),

  [AUTH_REQUEST_BBVA]: ({ commit, rootGetters }) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      auth.tokenBBVA(rootGetters['bbva/getBBVADataField']('codeBBVA')).then(
        resp => {
          lsSetAuthTokenBBVA(resp.data);
          resolve();
        },
        err => {
          commit(AUTH_ERROR, err);
          lsRemoveAuthTokenBBVA();
          reject();
        }
      );
    }),

  [AUTH_REQUEST_REFRESH_BBVA]: ({ commit }) =>
    new Promise((resolve, reject) => {
      const lsAuthTokenBBVA = lsGetAuthTokenBBVA();
      auth.tokenRefreshBBVA(lsAuthTokenBBVA.refresh_token).then(
        respRefresh => {
          lsSetAuthTokenBBVA(respRefresh.data);
          resolve();
        },
        err => {
          commit(AUTH_ERROR, err);
          lsRemoveAuthTokenBBVA();
          reject();
        }
      );
    })
};
